import React, { FC, useState } from "react"
import { Input } from "antd"
import { Link } from "react-router-dom"
import user from "../../../../assets/user.png"
import { SearchOutlined } from "@ant-design/icons"
import JobPostTable from "./table/JobPostTable"
import "../../../../styles/user.scss"

const JobPost: FC = () => {
  return (
    <div className="user">
      <div className="user-title">
        <h1>Jobs</h1>
      </div>
      <div className="task-dashboard" style={{ padding: "40px" }}>
        <div className="project-table">
          <JobPostTable />
        </div>
      </div>
    </div>
  )
}
export default JobPost
